<template>
  <div class="container">
    <van-cell-group class="group">
      <van-field label="用户名" :value="list.userName" readonly />
      <van-field label="姓名" :value="list.name" readonly />
      <van-field label="手机号" :value="list.phoneNumber" readonly />
      <!-- <van-field label="身份证号" :value="list.idCard" readonly /> -->
      <!-- <van-field label="出生日期" :value="list.birthDay" readonly />
      <van-field label="性别" :value="getChineseStatus(list.gender)" readonly /> -->
      <!-- <van-field name="uploader" label="身份证照片" class="IdCard">
        <template #input>
          <div class="myCard">
            <div
              v-for="item in list.pictures"
              :key="item.picturesId"
              class="itemID"
            >
              <van-image :src="item.pictureUrl" />
            </div>
          </div>
        </template>
      </van-field> -->
    </van-cell-group>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  CellGroup,
  Form,
  Field,
  Uploader,
  Image as VanImage,
  Notify,
  Overlay,
  Toast
} from "vant";
import service from "../../api/userCenterPage/userCenterPage";
import loading from "../../components/loading/loading";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [VanImage.name]: VanImage,
    [Notify.name]: Notify, 
    [Overlay.name]: Overlay,
    loading,
    Toast
  },
  data() {
    return {
      isLoading:true, //loading状态
      list: {},
    };
  },
  methods: {
    init(id) {
      service.detail(id).then((res) => {
        this.isLoading =false
        if (res.statusCode == 200) {
          // res.data.pictures.map((i) => {
          //   i.url = i.pictureUrl;
          //   i.isImage = true;
          // });
          this.list = res.data;
        } else {
          Toast(res.errors)
          // Notify({
          //   type: "danger",
          //   message: res.errors,
          // });
        }
      });
    },
    // getChineseStatus(status) {
    //   switch (status) {
    //     case 0:
    //       return "男";
    //     case 1:
    //       return "女";

    //     default:
    //       break;
    //   }
    // },
  },
  mounted() {
    this.init(this.$route.query.id);
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  height: calc(100% - 46px);
  overflow: auto;
  .van-cell {
    font-size: 4vw;
    padding: 0 6vw;
    line-height: 14.4vw;
    @{deep}.van-field__label {
      width: 78px;
      margin-right: 2vw;
      color: #000;
    }
    @{deep}.van-field__control {
      color: #919191;
      font-size: 3.6vw;
    }
  }
  .IdCard {
    padding: 4vw 4vw 3vw 6vw;
    .itemID {
      width: 31vw;
      height: 20vw;
      margin-right: 1.5vw;
      margin-bottom: 2vw;
    }
  }
  .myCard {
    display: flex;
    flex-wrap: wrap;
  }

  .group {
    box-shadow: 0px 18px 23px 1px rgba(0, 0, 0, 0.03);
  }
}
</style>